import React, { Component } from 'react';

import {ProgressBar} from 'react-bootstrap';
import axios from 'axios';

require(`../assets/${process.env.PAGE}/css/components/flow-progress-bar.css`);

class FlowProgressBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            progress: null,
            current_step: 0,
            total_steps: 0,
        }
    }

    componentDidMount(){
        const ROOT_URL = process.env.API_URL;
        if (process.env.PAGE !== 'montemar-adelantos'){
            return null;
        }
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/leads/steps/current_step`, config)
            .then((response) => {
                let progress = (response.data.current_step / response.data.total_steps) * 100
                progress = progress.toFixed();
                this.setState({
                    progress: progress,
                    current_step: response.data.current_step || 0,
                    total_steps: response.data.total_steps || 0,
                });
            }).catch(error => {
                let progress = (2 / 9) * 100
                progress = progress.toFixed(0);
                this.setState({
                    progress: progress
                });
            });

    }

    render() {
        const { progress, current_step, total_steps } = this.state;

        const progressBar = (
            <div className="row">
                <div className={'progress-step'}>
                    <p>{`Paso`} <b>{`${current_step}`}</b> {`de`} <b>{`${total_steps}`}</b></p>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                    <ProgressBar className={'flow-progress-bar'} now={progress} max={100} min={0}/>
                </div>
            </div>
        );

        const component = progress ? progressBar : (<div style={{marginTop: "40px"}}></div>);
        return component;
    }
}

export default FlowProgressBar;


/** WEBPACK FOOTER **
 ** ./src/components/FlowProgressBar.js
 **/